import { Controller, useFormContext } from "react-hook-form";

import FormToggleField from "ds/components/Form/ToggleField";
import { AriaInputProps } from "ds/components/Form/useAriaInputProps";
import Input from "ds/components/Input";
import SecretInput from "ds/components/SecretInput";
import { PluginTemplateParameter, PluginTemplateParameterType } from "types/generated";

import { InstallPluginFormValues } from "./types";

const ParameterInput = ({
  param,
  index,
  ariaInputProps,
}: {
  param: PluginTemplateParameter;
  index: number;
  ariaInputProps: AriaInputProps;
}) => {
  const {
    register,
    formState: { errors },
    control,
    setValue,
  } = useFormContext<InstallPluginFormValues>();

  setValue(`parameters.${index}.id`, param.id);

  if (param.sensitive) {
    return (
      <SecretInput
        placeholder={`Enter ${param.name}`}
        error={!!errors?.parameters?.[index]}
        {...register(`parameters.${index}.value`, {
          required: param.required ? `${param.name} is required` : false,
          setValueAs: (value) => value.trim(),
        })}
        {...ariaInputProps}
      />
    );
  }
  switch (param.type) {
    case PluginTemplateParameterType.String:
      return (
        <Input
          placeholder={`Enter ${param.name}`}
          error={!!errors?.parameters?.[index]}
          {...register(`parameters.${index}.value`, {
            required: param.required ? `${param.name} is required` : false,
            setValueAs: (value) => value.trim(),
          })}
          {...ariaInputProps}
        />
      );
    case PluginTemplateParameterType.Number:
      return (
        <Input
          placeholder={`Enter ${param.name}`}
          type="number"
          error={!!errors?.parameters?.[index]}
          {...register(`parameters.${index}.value`, {
            required: param.required ? `${param.name} is required` : false,
            setValueAs: (value) => value.trim(),
          })}
          {...ariaInputProps}
        />
      );
    case PluginTemplateParameterType.Boolean:
      return (
        <Controller
          name={`parameters.${index}.value`}
          control={control}
          rules={{
            required: param.required ? `${param.name} is required` : false,
          }}
          render={({ field }) => (
            <FormToggleField
              variant="switch"
              onChange={field.onChange}
              checked={Boolean(field.value)}
              title={param.name}
            />
          )}
        />
      );
    case PluginTemplateParameterType.None:
    default:
      return null;
  }
};

export default ParameterInput;
